import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';

import { BehaviorSubject, Observable, Subscription, timer, interval } from 'rxjs';
import { delay, retryWhen, switchMap, tap , map, filter, first, timeout} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AlarmService {
  private pharmacyAlarmUrl = environment.baseUrl + 'api/pharmacy/active-alarms';
  private dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public data$: Observable<any[]> = this.dataSubject.asObservable();
  private timerSubscription: Subscription;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.startAutoRefresh();
  }

  get alarmsList() {
    return this.dataSubject.getValue();
  }

  startAutoRefresh() {
    this.timerSubscription = timer(0, 60000)
      .pipe(switchMap(() => this.loadData()))
      .subscribe();
  }

  stopAutoRefresh() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  fetchDataOnClick() {
    return this.loadData();
  }

  private waitForToken(): Observable<boolean> {
    return interval(1000).pipe(
      map(() => {
        const jwt = this.authService.getCookie('jwt');
        return !!jwt && this.authService.isValidToken(jwt);
      }),
      filter(isValid => isValid),
      first(),
      timeout(30000)
    );
  }

  // private loadData(): Observable<any[]> {
  //   return this.http
  //     .get<any[]>(this.pharmacyAlarmUrl, {
  //       headers: this.authService.getJwtAuthHeaders(),
  //     })
  //     .pipe(
  //       tap((data) => this.dataSubject.next(data)),
  //       retryWhen((errors) =>
  //         errors.pipe(
  //           tap((error) => {
  //             if (error.status !== 502) {
  //               throw error;
  //             }
  //           }),
  //           delay(500)
  //         )
  //       )
  //     );
  private loadData(): Observable<any[]> {
    return this.waitForToken().pipe(
      switchMap(() => this.http.get<any[]>(this.pharmacyAlarmUrl, {
        headers: this.authService.getJwtAuthHeaders(),
      })),
      tap((data) => this.dataSubject.next(data)),
      retryWhen((errors) =>
        errors.pipe(
          tap((error) => {
            if (error.status !== 502) {
              throw error;
            }
          }),
          delay(500)
        )
      )
    );
  }

  endAlarm(id: number, desc: string): Observable<any> {
    return this.http.post(
      this.pharmacyAlarmUrl + '/' + id,
      {
        description: desc,
      },
      {
        headers: this.authService.getJwtAuthHeaders(),
      }
    );
  }
}
